import { useEffect, useRef } from 'react'

import { Form, FormRef } from '@tribeplatform/react-sdk/components'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

export const LinkFormDialog = ({
  onSubmit,
  onClose,
  open,
  defaultValues,
}: {
  open?: boolean
  defaultValues?: { text?: string; link?: string }
  onSubmit: (data: { link: string; text?: string }) => void
  onClose?: () => void
}) => {
  const textInputRef = useRef<HTMLInputElement>()
  const linkInputRef = useRef<HTMLInputElement>()
  const formRef = useRef<FormRef>()

  useEffect(() => {
    if (formRef?.current?.methods) {
      formRef.current.methods.setValue('text', defaultValues.text)
    }
  }, [defaultValues, formRef])

  return (
    <Modal
      open={open}
      onClose={onClose}
      initialFocus={defaultValues?.text ? linkInputRef : textInputRef}
    >
      <Modal.Header title="Add Link" />
      <Modal.Content>
        <Form
          ref={formRef}
          onSubmit={onSubmit}
          className="mt-5 space-y-6"
          defaultValues={defaultValues}
        >
          <Form.Input name="text" label="Text" ref={textInputRef} />
          <Form.Input
            ref={linkInputRef}
            name="link"
            autoComplete="href"
            label="Link"
          />
          <div className="mt-5 flex space-x-2 items-center justify-end">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Save
            </Button>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
